import { useEffect } from 'react';
import { analyticsEnabled, HOTJAR_ID } from './analyticsConfig.js';

// Loads Hotjar. The IIFE is the vendor snippet verbatim (it appends its own
// <script>), with the id/settings read from env.
const Hotjar = () => {
  useEffect(() => {
    if (!analyticsEnabled || !HOTJAR_ID) return;
    if (window.hj) return; // already injected

    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: HOTJAR_ID, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }, []);

  return null;
};

export default Hotjar;
